import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/types/graph';
import { useResetQuestionnaire } from '@/hooks/useResetQuestionnaire';

export const useResetStaleMmgBorneSession = () => {
  const reset = useResetQuestionnaire();
  const isStale = useSelector(
    (state: RootState) =>
      state.graph.variant === 'mmg_borne' &&
      (Boolean(state.questionnaireId) || Boolean(state.consultation.patient)),
  );
  const didReset = useRef(false); // Fire reset only once

  useEffect(() => {
    if (isStale && !didReset.current) {
      didReset.current = true;
      reset({ clearStorage: true });
    }
  }, [isStale, reset]);
};
